import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { O2AwardsReportFilterCriteria } from "./o2-portal-awards-by-region/O2AwardsReportFilterCriteria";

@Injectable({
    providedIn: 'root'
})

export class O2ReportFilters {
    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl + 'O2PortalAwards';

    getRegions() {
        return this.http.get<any[]>(this.baseurl);
    }

    getO2PortalAwardsData(filters: O2AwardsReportFilterCriteria) {
        return this.http.post<any[]>(this.baseurl + '/GetO2PortalAwardsData', filters);
    }
}